module.exports = __webpack_public_path__ + "img/ldorina.b164782a.jpg";